import React, { FC } from 'react';
import { Link } from 'react-router-dom';

import { ROUTE_ABOUT, ROUTE_TERMS, ROUTE_PRIVACY, ROUTE_ADVERTISE } from 'routes';
import { useAnalytics } from 'contexts/AnalyticsContext';
import { ANALYTICS_EVENTS } from 'constants/analyticsEvents';

import {
  StyledFooter,
  StyledLogo,
  StyledMainInfoContainer,
  StyledListsContainer,
  StyledListTitle,
  StyledCopyrightText,
  StyledLogoText,
  StyledLeftFooterContainer,
} from './styled';

const Footer: FC = () => {
  const { track } = useAnalytics();

  return (
    <StyledFooter>
      <StyledMainInfoContainer>
        <StyledLeftFooterContainer>
          <StyledLogo src="https://ivysaur-b-gql-image.s3.amazonaws.com/logo_white_svg.svg" alt="Logo" />
          <StyledLogoText>g:h</StyledLogoText>
        </StyledLeftFooterContainer>
        <StyledListsContainer>
          <div>
            <StyledListTitle>Company</StyledListTitle>
            <Link to={`${ROUTE_ABOUT}?welcome=true`} onClick={() => track(ANALYTICS_EVENTS.LandingAboutUs)}>
              About Us
            </Link>
            <a
              href="https://apps.apple.com/us/app/guide-human/id1570806527"
              onClick={() => track(ANALYTICS_EVENTS.LandingDownloadApp)}
            >
              Download the App
            </a>
            <Link to={`${ROUTE_ADVERTISE}`} onClick={() => track(ANALYTICS_EVENTS.LandingAdvertise)}>
              Advertise
            </Link>
            <a
              href="https://guide-human-store.myshopify.com"
              onClick={() => track(ANALYTICS_EVENTS.LandingOfficialStore)}
            >
              Official Store
            </a>
          </div>
          <div>
            <StyledListTitle>Information</StyledListTitle>
            <a href="mailto:hello@guidehuman.co" onClick={() => track(ANALYTICS_EVENTS.LandingContactUs)}>
              Contact Us
            </a>
            <Link to={ROUTE_TERMS} onClick={() => track(ANALYTICS_EVENTS.LandingTS)}>
              Terms of Service
            </Link>
            <Link to={ROUTE_PRIVACY} onClick={() => track(ANALYTICS_EVENTS.LandingPP)}>
              Privacy Policy
            </Link>
          </div>
        </StyledListsContainer>
      </StyledMainInfoContainer>
      <StyledCopyrightText>© {new Date().getFullYear()}, Guide Human Inc. All Rights Reserved.</StyledCopyrightText>
    </StyledFooter>
  );
};

export default Footer;
